import { render, staticRenderFns } from "./modalSubirAvatar.vue?vue&type=template&id=b56d8c4e&scoped=true"
import script from "./modalSubirAvatar.vue?vue&type=script&lang=js"
export * from "./modalSubirAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56d8c4e",
  null
  
)

export default component.exports